import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ChargebeePartnerDiscountCode } from '../models/partner-discount-code';

@Injectable({
  providedIn: 'root',
})
export class PartnersService {
  environment = environment;

  constructor(private http: HttpClient) {}

  fetchPartnerDiscountCode(code: string): Observable<ChargebeePartnerDiscountCode | { error: string }> {
    return this.http
      .get<{ data: ChargebeePartnerDiscountCode }>(`${this.environment.apiUrl}/billing/coupons/${code}`)
      .pipe(
        map((res) => (res.data ? res.data : null)),
        catchError((err: HttpErrorResponse) => {
          if (err.status === 400) {
            return of({ error: 'This discount code is no longer valid.' });
          } else {
            return of({ error: '' });
          }
        })
      );
  }

  stubFetchPartnerDiscountCode(code: string): Observable<ChargebeePartnerDiscountCode> {
    return of<ChargebeePartnerDiscountCode>({
      id: 'HostGPO-9a53da7b-0afd-4296-b8a7-791b4bb31540',
      name: 'HostGPO',
      discount_type: 'percentage',
      discount_percentage: 30,
      duration_type: 'limited_period',
      apply_on: 'invoice_amount',
      period: 6,
      period_unit: 'month',
    });
  }
}
